module.exports = __webpack_public_path__ + "static/media/medical-education-question.f798ca97.jpg";